import { useBoardTheme } from '@exports/hooks/useBoardTheme';

import { useClubCardQuery, useMyStatsQuery } from '@features/club/api/hooks';
import { ClubMyStats } from '@features/club/ui/ClubMyStats/ClubMyStats';
import { useGoToGame } from '@features/tournament/hooks/useGoToGame';
import { PlayerShieldQuickPeekWidget } from '@features/user/ui/PlayerShieldQuickPeek/PlayerShieldQuickPeekWidget';

type Props = {
  clubId: string;
};
export function ClubMyStatsWidget({ clubId }: Props) {
  const clubQuery = useClubCardQuery(clubId, { staleTime: Infinity });
  const isMember = clubQuery.data?.memberStatus === 'Active';
  const { boardTheme } = useBoardTheme();

  const goToGame = useGoToGame(clubId);
  const { data: stats } = useMyStatsQuery(clubId, {
    enabled: isMember,
  });

  if (!stats) {
    return null;
  }

  return (
    <ClubMyStats
      stats={stats}
      boardTheme={boardTheme}
      onGameClick={goToGame}
      enhanceHref="https://chessrussian.ru"
      renderQuickPeekWidget={(userId) => <PlayerShieldQuickPeekWidget userId={userId} />}
    />
  );
}
